import React from "react";
import classes from "./MainPage.module.css";
import emojy1 from "../assets/images/emojy/emojy1.png";
import SliderBox from "../components/sliderBox/SliderBox";
import Growth from "../components/growth/Growth";

const MainPage = () => {
  return (
    <div>
      <div className={`${classes["section-box"]} pt_20`}>
        <div className={classes["introduce-box"]}>
          안녕하세요.
          <br />
          저는 꾸준한 노력과 성실함으로 <strong>성장하고 있는 웹 개발자</strong>입니다.
          <br />
          배움의 과정을 소중히 여기며, 익힌 지식을 실무에 적용해 가치를 만들어 내는 데 집중하고 있습니다.
          <br />
          앞으로도 책임감을 바탕으로 신뢰받는 개발자가 되기 위해 최선을 다하겠습니다.
          <br />
          감사합니다!
        </div>
        <div className={classes["introduce-img-box"]}>
          <img src={emojy1} />
        </div>
      </div>

      <h2 className={classes["title"]}>PORTFOLIO</h2>
      <div className={classes["section-box"]}>
        <SliderBox />
      </div>

      <h2 className={classes["title"]}>SKILL</h2>
      <div className={classes["section-box"]}>
        <Growth />
      </div>
    </div>
  );
};

export default MainPage;
